import { render, staticRenderFns } from "./MostTruck.vue?vue&type=template&id=def52fa0&"
import script from "./MostTruck.vue?vue&type=script&lang=js&"
export * from "./MostTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports